import { observable, action, autorun } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';

class DataStore {
  markerBounds = [[-75, -75], [75, 75]];

  @observable loadingDatasetList;
  @observable loadingDataset;
  @observable loadingMap = false;
  @observable loadingNearestPoi = false;
  @observable loadingExportCurves = false;
  @observable loadingExportMaps = false;

  @observable datasetList = [];
  @observable circlesInfo = [];
  @observable meanPoeArray = [];
  @observable p02PoeArray = [];
  @observable p16PoeArray = [];
  @observable p50PoeArray = [];
  @observable p84PoeArray = [];
  @observable p98PoeArray = [];
  @observable markerLoc = null;
  @observable poiCode = null;
  @observable meanMihArray = [];
  @observable p02MihArray = [];
  @observable p16MihArray = [];
  @observable p50MihArray = [];
  @observable p84MihArray = [];
  @observable p98MihArray = [];

  @observable deletingError;
  @observable deletingDataset;

  @observable updatingDataset;

  @observable datasetSubmitError;
  @observable getNearestPoiError;
  @observable exportCurvesError;
  @observable exportMapsError;

  @observable currentDataset = 0;
  @observable currentMaptype = 'hazard'; // hazard , probability
  @observable currentStatistic = 'mean'; // mean, p02, p16, p50, p84, p98
  @observable currentStatisticLabel = 'mean'; // mean, 2nd, th16, th50, th84, th98
  @observable currentMihPoe = '2475';
  @observable currentDatasetName = '';
  @observable currentDocumentationLink = '';
  @observable currentLiabilityClaim = '';
  @observable currentCitation = '';
  @observable currentLogoURL = '';
  @observable currentDatasetMinLat = -179.5;
  @observable currentDatasetMinLng = -179.5;
  @observable currentDatasetMaxLat = 179.5;
  @observable currentDatasetMaxLng = 179.5;

  @observable initialDatasetName = null;

  @observable isModalActive = false;

  @action
  getDatasetList() {
    this.loadingDatasetList = true;
    console.log("Going to request agent.Data.getDataset");
    return agent.Data.getDataset()
      .then(response => {
        console.log("Response received****:", response);
        action(() => {
          console.log("Inside action");
          this.datasetList = response.status && response.content;
          console.log("Dataset List:", this.datasetList);
          if (this.datasetList) {
            this.datasetList.forEach(ds => {
              console.log("Inside forEach loop");
              if (
                (this.initialDatasetName && this.initialDatasetName === ds.name)
                || ds.id === this.currentDataset
              ) {

                console.log("^^^^^^^^")
                console.log(ds.logo)
                this.currentDataset = ds.id;
                this.currentDatasetName = ds.name;
                this.currentDocumentationLink = ds.documentationLink;
                this.currentLiabilityClaim = ds.liabilityClaim;
                this.currentCitation = ds.citation;
                this.currentLogoURL = ds.logo;
                this.currentDatasetMinLat = ds.minLat;
                this.currentDatasetMaxLat = ds.maxLat;
                this.currentDatasetMinLng = ds.minLng;
                this.currentDatasetMaxLng = ds.maxLng;
                this.markerBounds = [[-1, -1], [1, 1]];
                this.markerBounds = [
                  [this.currentDatasetMinLat - 0.5, this.currentDatasetMinLng - 0.5],
                  [this.currentDatasetMaxLat + 0.5, this.currentDatasetMaxLng + 0.5]
                ];
                console.log("wwwwwww");
              }
            });
          }
        })();
      })
      .finally(() => {
        action(() => {
          this.loadingDatasetList = false;
        })();
      });
  }

  @action
  deleteDataset(name) {
    this.deletingDataset = true;
    this.deletingError = null;

    return agent.Data.delete(name)
      .then(res => res)
      .catch(
        action(err => {
          const responseBody = err.response.body;
          this.deletingError =
            {
              type: responseBody.content,
              details: responseBody.details || null,
            } || err;
        })
      )
      .finally(
        action(() => {
          this.deletingDataset = false;
        })
      );
  }

  @action
  // submit({ name, liabilityClaim, citation logo, mean, p02, p16, p50, p84, p98 }) {
  submit({ name, liabilityClaim, citation, documentationLink, logo, mean, p02, p16, p50, p84, p98 }) {
    this.loadingDataset = true;
    this.datasetSubmitError = undefined;

    // return agent.Data.submit(name, liabilityClaim, citation, logo, mean, p02, p16, p50, p84, p98)
    return agent.Data.submit(name, liabilityClaim, citation, documentationLink, logo, mean, p02, p16, p50, p84, p98)
      .catch(
        action(err => {
          const responseBody = err.response.body;
          this.datasetSubmitError =
            {
              type: responseBody.content,
              details: responseBody.details || null,
            } || err;
        })
      )
      .finally(
        action(() => {
          this.loadingDataset = false;
        })
      );
  }

  @action
  updateDataset(id, values) {
    this.updatingDataset = true;
    values.id = id;
    return agent.Data.updateDataset(values).then(() => {
      this.updatingDataset = false;
    });
  }

  // non viene più chiamata perchè ora quando cambia il dataset selezionato
  // viene ricaricata la pagina cambiando la URL
  // @action
  // setCurrentDataset(dataset) {
  //   this.currentDataset = dataset;
  //   this.datasetList.forEach(ds => {
  //     if (ds.id === parseInt(dataset)) {
  //       this.currentLogoURL = ds.logo;
  //       this.currentDatasetName = ds.name;
  //       this.currentDocumentationLink = ds.documentationLink;
  //       this.currentDatasetMinLat = ds.minLat;
  //       this.currentDatasetMaxLat = ds.maxLat;
  //       this.currentDatasetMinLng = ds.minLng;
  //       this.currentDatasetMaxLng = ds.maxLng;
  //     }
  //   });
  // }


  @action
  getDatasetNameById(f, id) {
    this.datasetList.forEach(ds => {
      if (ds.id === id) {
        f(ds.name);
      }
    });
  }

  // @action
  // setCurrentDatasetByName(datasetName) {
  //   // this.currentDataset = dataset;
  //   this.datasetList.forEach(ds => {
  //     if (ds.name === datasetName) {
  //       this.currentLogoURL = ds.logo;
  //       this.currentDatasetName = ds.name;
  //       this.currentDatasetMinLat = ds.minLat;
  //       this.currentDatasetMaxLat = ds.maxLat;
  //       this.currentDatasetMinLng = ds.minLng;
  //       this.currentDatasetMaxLng = ds.maxLng;
  //       this.currentDataset = ds.id;
  //     }
  //   });
  // }

  @action
  setCurrentMaptype(maptype) {
    this.currentMaptype = maptype;
  }

  @action
  // eslint-disable-next-line class-methods-use-this
  getCurrentStatisticLabel() {
    if (this.currentStatistic === 'mean') {
      return 'mean';
    }
    if (this.currentStatistic === 'p02') {
      return '2nd';
    }
    if (this.currentStatistic === 'p16') {
      return '16th';
    }
    if (this.currentStatistic === 'p50') {
      return '50th';
    }
    if (this.currentStatistic === 'p84') {
      return '84th';
    }
    if (this.currentStatistic === 'p98') {
      return '98th';
    }
  }

  @action
  setCurrentStatistic(statistic) {
    console.log(`datastore.setCurrentStatistic value: ${statistic}`)
    this.currentStatistic = statistic;
    this.currentStatisticLabel = this.getCurrentStatisticLabel();
  }

  @action
  setCurrentMihPoe(mihPoe) {
    this.currentMihPoe = mihPoe;
  }

  @action
  setCirclesInfo(circleColLoc) {
    this.circlesInfo = circleColLoc;
  }

  @action
  getNearestPoi(latlng) {
    this.loadingNearestPoi = true;
    const stringLatLng = `${latlng[0]},${parseFloat(latlng[1])}`;
    console.log("BBBBBB")
    console.log(stringLatLng)
    return agent.Data.getNearestPoi(encodeURIComponent(stringLatLng))
      .catch(
        action(err => {
          const responseBody = err.response.body;
          this.getNearestPoiError =
            {
              type: responseBody.content,
              details: responseBody.details || null,
            } || err;
        })
      )
      .finally(
        action(() => {
          this.loadingNearestPoi = false;
        })
      );
  }

  @action
  setCurveData(result) {
    if (result[0]) {
      this.isModalActive = true;

      this.markerLoc = [result[1], result[2]];
      this.poiCode = result[3];

      const poeArray = result[0][0].map(element => element.poe);
      this.meanMihArray = result[0][0].map(element => element.mih);
      this.p02MihArray = result[0][1].map(element => element.mih);
      this.p16MihArray = result[0][2].map(element => element.mih);
      this.p50MihArray = result[0][3].map(element => element.mih);
      this.p84MihArray = result[0][4].map(element => element.mih);
      this.p98MihArray = result[0][5].map(element => element.mih);

      this.meanMihArray = this.meanMihArray.filter(function (el) {return el != "None";});
      this.meanPoeArray = poeArray.slice(poeArray.length - this.meanMihArray.length);

      this.p02MihArray = this.p02MihArray.filter(function (el) {return el != "None";});
      this.p02PoeArray = poeArray.slice(poeArray.length - this.p02MihArray.length);

      this.p16MihArray = this.p16MihArray.filter(function (el) {return el != "None";});
      this.p16PoeArray = poeArray.slice(poeArray.length - this.p16MihArray.length);

      this.p50MihArray = this.p50MihArray.filter(function (el) {return el != "None";});
      this.p50PoeArray = poeArray.slice(poeArray.length - this.p50MihArray.length);

      this.p84MihArray = this.p84MihArray.filter(function (el) {return el != "None";});
      this.p84PoeArray = poeArray.slice(poeArray.length - this.p84MihArray.length);

      this.p98MihArray = this.p98MihArray.filter(function (el) {return el != "None";});
      this.p98PoeArray = poeArray.slice(poeArray.length - this.p98MihArray.length);
    }
  }

  @action
  closeCurveModal() {
    this.isModalActive = false;
  }

  @action
  exportCurves(datasetId) {
    this.loadingExportCurves = true;
    return agent.Data.exportCurves(datasetId)
      .then(res => {
        
        const blob = new Blob([res], { type: 'octet/stream' });
        const url = URL.createObjectURL(blob);

        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', `${this.currentDatasetName}-hazard_curves.zip`);
        tempLink.click();
      })
      .finally(
        action(() => {
          this.loadingExportCurves = false;
        })
      );
  }

  @action
  exportMaps(datasetId) {
    this.loadingExportMaps = true;
    return agent.Data.exportMaps(datasetId)
      .then(res => {
        const blob = new Blob([res], { type: 'octet/stream' });
        const url = URL.createObjectURL(blob);

        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', `${this.currentDatasetName}-maps.zip`);
        tempLink.click();
      })
      .finally(
        action(() => {
          this.loadingExportMaps = false;
        })
      );
  }

  constructor() {
    autorun(
      () => {
        console.log(`autorun FIRED!!! this.currentStatistic=${this.currentStatistic}, currentDataset=${this.currentDataset}`)
        console.log(`autorun FIRED!!! token=${commonStore.token}, currentDataset=${this.currentDataset}`)
        // SERGIO_AUTH_ORIG if (commonStore.token && this.currentDataset !== 0) {
        // SERGIO_AUTH_NEW if (this.currentDataset !== 0) {
        
        if (this.currentDataset !== 0) {
          console.log("RITAAAAAAAAAA")
          console.log(this.currentDataset)
          this.loadingMap = true;
          console.log(`Going to request agent.Data.getMap with following params: ${this.currentDataset}-${this.currentMaptype}-${this.currentStatistic}-${this.currentMihPoe}`)
          agent.Data.getMap(
            `${this.currentDataset}-${this.currentMaptype}-${this.currentStatistic}-${this.currentMihPoe}`
          )
            .then(
              action(response => {
                const circleColLoc = response.content; // [Circle Color, Circle Location]
                this.setCirclesInfo(circleColLoc);
              })
            )
            .finally(
              action(() => {
                this.loadingMap = false;
              })
            );
        }
      },
      {
        delay: 100,
      }
    );
  }
}

export default new DataStore();



// WEBPACK FOOTER //
// ./src/store/dataStore.js